module.exports = __webpack_public_path__ + "static/img/ability-img4.7ca28ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/ability-img4.png
// module id = hxdK
// module chunks = 2